<div class="container my-5">
    <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-8">
            <div class="card" style="border: 1px solid rgba(0,0,0,.125);border-radius: .25rem;">
                <div class="card-body">
                    <div class="bg-default w-100  text-center mb-3">
                        <h2 class="card-title">
                            RECEPCIÓN Y SEGUIMIENTO DE QUEJAS Y DENUNCIAS A FUNCIONARIOS PÚBLICOS
                        </h2>
                    </div>

                    <div class="row">
                        <div class="col-lg-10 mx-auto">
                            <form class="card  p-3" id="contact-form" (ngSubmit)="enviar(m)" #f="ngForm">
                                <div class="card-body">
                                    <div class="form-group mb-4">
                                        <h6 class="card-subtitle mb-2">Tipo de Reporte</h6>
                                        <select class="form-control" [(ngModel)]="forma.idsolicitud_tipo" name="IdServicio">
                                            <option *ngFor="let item of tipos" value="{{item.idsolicitud_tipo}}">
                                                {{item.solicitud_tipo}}
                                            </option>
                                        </select>
                                    </div>
                                    <!--   <div class="form-group">
                                            <label> TIPO DE REPORTE </label>
                                            <ng-select aria-label="Tipo..." [items]="tipos" bindLabel="solicitud_tipo"
                                                bindValue="idsolicitud_tipo" [(ngModel)]="forma.idsolicitud_tipo" name="idServicio" [required]>
                                            </ng-select>
                                        </div>-->
                                    <div class="bg-default w-100  text-center">
                                        <h5>DATOS PERSONALES</h5>
                                    </div>
                                    <div class="form-group text-center mt-3">
                                        <button class="btn btn-secondary" *ngIf="forma.anonimo" (click)="forma.anonimo = false">
                                                ANÓNIMO</button>
                                        <button class="btn btn-primary" *ngIf="!forma.anonimo" (click)="forma.anonimo = true">
                                                ANÓNIMO</button>
                                    </div>
                                    <div *ngIf="!forma.anonimo">
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Nombre</h6>
                                            <input aria-label="Nombre..." class="form-control" placeholder="Escribe tu nombre..." type="text" [(ngModel)]="forma.nombre" name="nombre" required />
                                        </div>
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Apellido Paterno</h6>
                                            <input aria-label="Apellido Paterno..." class="form-control" placeholder="Escribe tu apellido paterno..." type="text" [(ngModel)]="forma.paterno" name="paterno" required />
                                        </div>
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Apellido Materno</h6>
                                            <input aria-label="Apellido Materno..." class="form-control" placeholder="Escribe tu apellido materno..." type="text" [(ngModel)]="forma.materno" name="materno" required />
                                        </div>
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Calle</h6>
                                            <input aria-label="Apellido Materno..." class="form-control" placeholder="Escribe tu apellido materno..." type="text" [(ngModel)]="forma.calle" name="calle" required />
                                        </div>
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Número</h6>
                                            <input aria-label="Apellido Materno..." class="form-control" placeholder="Escribe tu apellido materno..." type="text" [(ngModel)]="forma.numero" name="numero" required />
                                        </div>
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Colonia</h6>
                                            <input aria-label="Apellido Materno..." class="form-control" placeholder="Escribe tu apellido materno..." type="text" [(ngModel)]="forma.colonia" name="colonia" required />
                                        </div>
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Teléfono</h6>
                                            <input aria-label="Telefono..." class="form-control" placeholder="Escribe tu teléfono..." type="text" mask="(000) 000 0000" [dropSpecialCharacters]="false" [(ngModel)]="forma.telefono" name="telefono" required />
                                        </div>
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Email</h6>
                                            <input class="form-control" placeholder="Escribe tu correo electronico..." type="email" [(ngModel)]="forma.correo" name="correo" required />
                                        </div>







                                    </div>

                                    <div class="bg-default w-100  text-center">
                                        <h5>DATOS DE DEPENDENCIA O SERVIDOR PÚBLICO</h5>
                                        <br>
                                        <h6 style="color: rgba(49, 48, 48, 0.793);">ES IMPORTANTE MENCIONAR DATOS QUE HAGAN IDENTIFICABLE AL SERVIDOR PUBLICO QUE LO ATENDIO</h6>
                                        <br>
                                    </div>
                                    <div class="form-group text-center mt-3">
                                        <button class="btn btn-secondary" *ngIf="forma.no_aplica" (click)="forma.no_aplica = false"> NO
                                                APLICA O NO SE TIENE INFORMACIÓN DE
                                                PUESTO/ÁREA</button>
                                        <button class="btn btn-primary" *ngIf="!forma.no_aplica" (click)="forma.no_aplica = true">
                                                NO APLICA O NO SE TIENE INFORMACIÓN DE PUESTO/ÁREA</button>
                                    </div>
                                    <div *ngIf="!forma.no_aplica">
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Nombre</h6>
                                            <input aria-label="" class="form-control" placeholder="" type="text" [(ngModel)]="forma.servidor" name="servidor" required />
                                        </div>
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Puesto</h6>
                                            <input aria-label="" class="form-control" placeholder="" type="text" [(ngModel)]="forma.puesto" name="puesto"  />
                                        </div>
                                        <div class="form-group mb-4">
                                            <h6 class="card-subtitle mb-2">Area</h6>
                                            <input aria-label="A" class="form-control" placeholder="" type="text" [(ngModel)]="forma.area" name="area"  />
                                        </div>




                                    </div>

                                    <div class="bg-default w-100  text-center">
                                        <h5>COMENTARIOS</h5>
                                    </div>
                                    <div class="form-group">
                                        <label> A continuación redacte su experiencia de manera clara y concisa, tratando de no
                                                omitir ningún dato que considere relevante para poder atender su petición.</label>
                                        <textarea class="form-control form-control-alternative" id="message" name="message" rows="6" [(ngModel)]="forma.situacion" name="situacion" required></textarea>
                                    </div>
                                    <div class="bg-default w-100  text-center">
                                        <h5> ARCHIVOS </h5>
                                    </div>

                                    <div class="form-group">
                                        <div class="file-upload-wrapper">
                                            <div class="file-box file-box-body view file-upload">
                                                <div class="file-box-text file-upload-message"><i class="fa  fa-cloud-upload" [ngClass]="{'text-primary': nombre}"></i>
                                                    <p>Arrastrar archivo o click</p>
                                                    <p style="color:#67757c;" *ngIf="nombre!=''">
                                                        {{nombre}}</p>
                                                </div>
                                                <input type="file" (change)="cambioImg($event)" name="file-1[]" id="file-1" class="inputfile inputfile-1 file_upload" accept="image/png, image/jpeg" multiple />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox mb-3">
                                            <input class="custom-control-input" id="aviso_privacidad" type="checkbox" [(ngModel)]="forma.aviso_privacidad" name="aviso_privacidad" />

                                            <label class="custom-control-label" for="aviso_privacidad" [ngClass]="{'text-danger':!forma.aviso_privacidad}">
                                                    <span><a href="https://nld.gob.mx/assets/documentos/aviso_simplificado.pdf" target="_blank">AVISO DE PRIVACIDAD PARA LA PROTECCIÓN DE DATOS PERSONALES.</a></span>
                                                </label>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="custom-control custom-checkbox mb-3">
                                            <input class="custom-control-input" id="consentimiento_datos" type="checkbox" [(ngModel)]="forma.consentimiento_datos" name="consentimiento_datos" />

                                            <label class="custom-control-label" for="consentimiento_datos" [ngClass]="{'text-danger': !forma.consentimiento_datos}">
                                                    <span>DOY MI CONSENTIMIENTO AL GOBIERNO DE NUEVO LAREDO, PARA EL TRATAMIENTO
                                                        DE MIS DATOS PERSONALES, CON LA FINALIDAD ESPECÍFICIA DE DARLE SEGUIMIENTO Y
                                                        TRÁMITE HASTA SU CONCLUSIÓN, A LA PRESENTE DENUNCIA.</span>
                                                </label>
                                        </div>
                                    </div>
                                    <div class="row pull-right">
                                        <div class="col-md-12">
                                            <ngx-recaptcha2 ngModel name="captcha" [siteKey]="siteKey" (success)="handleSuccess($event)" [useGlobalDomain]="false" [hl]="lang" (expire)="handleExpire($event)">
                                            </ngx-recaptcha2>
                                        </div>
                                    </div>


                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <button class="btn btn-primary pull-right" type="submit" data-target="#modal-notification" [disabled]="f.invalid || !forma.aviso_privacidad || !forma.consentimiento_datos || !captcha">
                                                    <!-- <span *ngIf="!loading"> Enviar</span> -->
                                                    <span> Enviar</span>
                                                 <!--   <i class='fa fa-sync fa-spin' *ngIf="loading"></i>-->
                                                </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-2"></div>

        <div class="row">
            <div aria-hidden="true" aria-labelledby="modal-notification" bsModal class="modal fade" #m="bs-modal" id="modal-notification" role="dialog" tabindex="-1">
                <div class="modal-dialog modal-info modal-dialog-centered modal-" role="document">
                    <div class="modal-content bg-gradient-info">
                        <div class="modal-header">
                            <h6 class="modal-title" id="modal-title-notification">
                                ¡Solicitud enviada con éxito!
                            </h6>
                            <button aria-label="Close" class="close" data-dismiss="modal" (click)="m.hide();limpiar()" type="button">
                                <span aria-hidden="true"> × </span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="py-3 text-center">
                                <i class="ni ni-bell-55 ni-3x"> </i>
                                <h2 class="heading mt-4">FOLIO: {{folio}} </h2>
                                <p style="font-weight: bolder; text-align: justify;">
                                    Se ha descargado un archivo pdf con su formato de solicitud, en caso de no haberse descargado automaticamente presionar el boton de "Descargar PDF."
                                </p>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-white" type="button" (click)="descargar()">
                                <i class="fa fa-file-pdf-o"></i> Descargar PDF
                            </button>
                            <button class="btn btn-link text-white ml-auto" data-dismiss="modal" (click)="m.hide();limpiar()" type="button">
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div aria-hidden="true" aria-labelledby="modal-notification" bsModal class="modal fade" #c="bs-modal" id="modal-notification" role="dialog" tabindex="-1">
                <div class="modal-dialog modal-info modal-dialog-centered modal-" role="document">
                    <div class="modal-content bg-gradient-info">
                        <div class="modal-header">
                            <h6 class="modal-title" id="modal-title-notification">
                                ¡Atención!
                            </h6>
                            <button aria-label="Close" class="close" data-dismiss="modal" (click)="c.hide()" type="button">
                                <span aria-hidden="true"> × </span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="py-3 text-center">
                                <i class="fa fa-times fa-3x"> </i>

                                <p style="font-weight: bolder; text-align: justify;">
                                    El número máximo de archivos permitidos son 6.
                                </p>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-primary text-white ml-auto" data-dismiss="modal" (click)="c.hide()" type="button">
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>




</div>